import carnavals from './../images/carnavals.jpg';
import cicles from "./../images/cicles.jpg";
import concerts from "./../images/concerts.jpg";
import conferencies from "./../images/conferencies.jpg";
import cursos from "./../images/cursos.jpg";
import dansa from "./../images/dansa.jpg";
import exposicions from "./../images/exposicions.jpg";
import festivals_i_mostres from "./../images/festivals_i_mostres.jpg";
import fires_i_mercats from "./../images/fires_i_mercats.jpg";
import infantil from "./../images/infantil.jpg";
import festes from "./../images/festes.jpg";
import rutes_i_visites from "./../images/rutes_i_visites.jpg";
import sardanes from "./../images/sardanes.jpg";
import setmana_santa from "./../images/setmana_santa.jpg";
import teatre from "./../images/teatre.jpg";
import undefined_event from "./../images/undefined_event.jpg";
import logo from "./../images/logo.png";



export const eventsCategories = {
    carnavals: carnavals,
    cicles: cicles,
    concerts: concerts,
    conferencies: conferencies,
    cursos: cursos,
    dansa: dansa,
    infantil: infantil,
    exposicions: exposicions,
    festivals_i_mostres: festivals_i_mostres,
    fires_i_mercats: fires_i_mercats,
    festes: festes,
    rutes_i_visites: rutes_i_visites,
    sardanes: sardanes,
    setmana_santa: setmana_santa,
    teatre: teatre,
    undefined_event: undefined_event,
    logo: logo,
}